import { View } from 'backbone.marionette';
import template from './index.jst';
import { Model } from 'backbone';
import Radio from "backbone.radio";
import RoundSlider from "../../../../../core/views/components/RoundSlider";
import { MatchCentreMatchSelect } from "../MatchCentreMatchSelect";
const MATCH_CENTRE_CHANNEL = Radio.channel('match_centre');

export class MatchCentreControls extends View {
	get template() {
		return template;
	}


	childViewEvents() {
		return {
			'round:changed': 'onRoundChanged'
		}
	}

	regions() {
		return {
			round_selector: '.js-rounds-select',
			match_selector: '.js-match-select'
		}
	}

	initialize() {
		this.model = new Model({
			rounds: [],
			selected_round: {
				matches: []
			}
		});

		this.setLayout();
	}

	setLayout() {

		if (!this.getRegion('round_selector').hasView()) {
			this.showChildView('round_selector', new RoundSlider());
		}

		if (!this.getRegion('match_selector').hasView()) {
			this.showChildView('match_selector', new MatchCentreMatchSelect());
		}

		return this;
	}

	init(args) {
		const { rounds, selected_round } = args;
		this.initRoundSlider({ rounds, selected: selected_round.id })
			.initMatchSelect(selected_round);
	}

	initRoundSlider({ rounds, selected }) {
		this.getChildView('round_selector').init({ rounds, selected });

		return this;
	}

	initMatchSelect(selected_round) {
		this.getChildView('match_selector').init(selected_round);

		return this;
	}

	onRoundChanged(round_id) {
		MATCH_CENTRE_CHANNEL.trigger('controls:round:changed', round_id)
	}
}

export default MatchCentreControls;